import React from 'react';
import '../template-file-css/document-file-template.css';



export const BTCS_ClientIncidentReport = ({
    itemsRef,
    showErrorFor,

}) => {

    return (
        <form id='BTCS_ClientIncidentReport' className='file-pdf-document'>
            <div className='file-template'>
                <p className='w-750'><h3><center>CLIENT INCIDENT REPORT FORM</center></h3></p>

                <table>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Clinician Name:</span></td>
                        <td className='w-375'><span className='eleHeader'>Client Name: </span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtClinician' name='txtClinician' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClientName' name='txtClientName' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Phone Number:</span></td>
                        <td className='w-375'><span className='eleHeader'>Client Record #</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='text' id='txtPhoneNumber' name='txtPhoneNumber' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtClientRecord' name='txtClientRecord' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Date of Birth</span></td>
                        <td className='w-375'><span className='eleHeader'>Date of Incident:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfBirth' name='txtDateOfBirth' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='date' id='txtDateOfIncident' name='txtDateOfIncident' className='add-only' /></td>

                    </tr>
                    <tr>
                        <td className='w-375'><span className='eleHeader'>Time of Incident: </span></td>
                        <td className='w-375'><span className='eleHeader'>Location of Incident:</span></td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='time' id='txtTimeOfIncident' name='txtTimeOfIncident' className='add-only' /></td>
                        <td className='w-375'>
                            <input type='text' id='txtLocationOfIncident' name='txtLocationOfIncident' className='add-only' /></td>

                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please indicate who you notified on BTCS Leadership Team, include time and method of notification: </span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPleaseIndicateWhoYouNotified' name='txtPleaseIndicateWhoYouNotified' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>


                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Type of Incident: </span></td>
                    </tr>

                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_1' name='rbTypeOfIncident' className='add-only' value='PhysicalAssault' /> Physical assault on a clientperpetrated by a provider not occurring at a provider site</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_2' name='rbTypeOfIncident' className='add-only' value='FireAtProvider' /> Fire at provider site requiring emergency services of the fire department</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_3' name='rbTypeOfIncident' className='add-only' value='SeriousOrPotentially' /> Serious or potentially lethal suicide attempt</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_4' name='rbTypeOfIncident' className='add-only' value='AllegationOfSexual' /> Allegation of sexual contact by client against a provider</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_5' name='rbTypeOfIncident' className='add-only' value='Injury' /> Injury or illness while on provider site requiring medical attention</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_6' name='rbTypeOfIncident' className='add-only' value='ApparentHomeicide' /> Apparent homicide by client</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_7' name='rbTypeOfIncident' className='add-only' value='ApparentSexualAssault' /> Apparent sexual assault perpetrated by client</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_8' name='rbTypeOfIncident' className='add-only' value='AllegationOfPhysicalAbuse' /> Allegation of physical abuse by client against a provider</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_9' name='rbTypeOfIncident' className='add-only' value='ApparentSerious' /> Apparent serious physical assault perpetrated by client</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_10' name='rbTypeOfIncident' className='add-only' value='ArrestWhileInTreatment' /> Arrest while in treatment or within 30 days of treatmen</td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_11' name='rbTypeOfIncident' className='add-only' value='PhysicalAssualt' /> Physical assault on a client occurring at a provider site</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_12' name='rbTypeOfIncident' className='add-only' value='WasCalled' /> 911 was called</td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type='radio' id='rbTypeOfIncident_13' name='rbTypeOfIncident' className='add-only' value='Death' /> Death</td>

                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type='radio' id='rbTypeOfIncident_14' name='rbTypeOfIncident' className='add-only' value='Other' /> Other:
                            <input type='text' id='txtOther' name='txtOther' className='add-only w-350 custom-add-only' /></td>

                    </tr>

                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Please describe the incident in detail:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPleaseDescribeTheIncidentInDetail' name='txtPleaseDescribeTheIncidentInDetail' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>{`Please describe the actions taken and/or expected follow-up steps (i.e., include notifications made to ADAMH/CMH Board, Children Services Board, Family/Guardian, OhioMHAS, CCDCFS, 911,
                and/or Other Protective Agency and be sure to include Record/Case Numbers and the name of who
                you spoke with): `}</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtPleaseDescribeTheActionTaken' name='txtPleaseDescribeTheActionTaken' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'><td className='small w-375'> Signature of Appropriately Licensed Practitioner & Credentials </td>
                        </td>
                        <td className='small w-375'> Date of Report: </td>
                    </tr>
                </table>

                <p className='w-750'><h3><center>FOR ADMIN ONLY</center></h3></p>

                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Administrator recommendation/follow-up:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <textarea id='txtAdministratorRecommendation' name='txtAdministratorRecommendation' className='add-only'></textarea>
                        </td>
                    </tr>
                </table>

                <table>
                    <tr>
                        <td className='signature w-375'>&nbsp; </td>
                        <td className='signature w-375'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-375'><td className='small w-375'>Administrators' Signature:</td>
                        </td>
                        <td className='small w-375'>Date:</td>
                    </tr>
                </table>





            </div>
        </form>

    )
}  
